import { useSyncExternalStore } from 'react';
import { PROGRAMMES } from './tvecTemplates';

// The course (programme) chosen in the TVEC top bar. Every TVEC page follows it.
// A small shared store is used instead of React context because each page renders the
// layout (and its top bar) itself, so the page and the top bar are not parent and child.
export const ALL_COURSES_ID = 'all';

// The real courses (programmes), in dropdown order.
export const COURSE_PROGRAMMES = ['hnd', 'diit', 'dim']
  .map((id) => PROGRAMMES.find((p) => p.id === id))
  .filter(Boolean);

// "All courses" comes first in the dropdown; HND Computing is still the default.
export const TVEC_COURSES = [
  { id: ALL_COURSES_ID, label: 'All courses', short: 'All courses' },
  ...COURSE_PROGRAMMES,
];

export const DEFAULT_TVEC_COURSE = 'hnd';
const STORAGE_KEY = 'tvecCourse';
const isCourse = (id) => TVEC_COURSES.some((c) => c.id === id);

const read = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return isCourse(saved) ? saved : DEFAULT_TVEC_COURSE;
  } catch {
    return DEFAULT_TVEC_COURSE;
  }
};

let current = read();
const listeners = new Set();

export function setTvecCourse(id) {
  if (!isCourse(id) || id === current) return;
  current = id;
  try { window.localStorage.setItem(STORAGE_KEY, id); } catch { /* storage unavailable */ }
  listeners.forEach((fn) => fn());
}

const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export function useTvecCourse() {
  const courseId = useSyncExternalStore(subscribe, () => current, () => DEFAULT_TVEC_COURSE);
  return {
    courseId,
    course: TVEC_COURSES.find((c) => c.id === courseId) || TVEC_COURSES[0],
    courses: TVEC_COURSES,
    setCourse: setTvecCourse,
  };
}
